import { svg, render } from 'lit-html';

export default {
  dashboardIcon: svg`
    <style>
      svg.active path.dashboard-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      svg.active path.dashboard-background { fill: transparent; transition: all 250ms ease-in; }
      [dark] svg.active path.dashboard-background { transition: all 250ms ease-in; }
      .dashboard-outline { fill: #00000055; }
      .dashboard-background { fill: transparent; }
      [dark] .dashboard-outline { fill: rgba(255, 255, 255, 0.1); }
    </style>
    <path fill="none" d="M0 0h24v24H0V0z"/>
    <path class="dashboard-background" d="M20.8,19.6c0.3-0.6-0.3-15.7-0.3-15.7L3.7,3.5l-0.1,17c0,0,15.2,0.6,15.9,0.4C20.2,20.6,20.6,20.3,20.8,19.6z"/>
    <path class="dashboard-outline" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/>
`,
  phoneIcon: svg`
    <style>
      svg.active path.phone-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      .phone-outline { fill: #00000033; }
      [dark] .phone-outline { fill: rgba(255, 255, 255, 0.05); }
    </style>
    <path d="M0 0h24v24H0z" fill="none"/>
    <path class="phone-outline" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
`,
  chatIcon: svg`
    <style>
      svg.active path.chat-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      svg.active path.chat-background { fill: transparent; transition: all 250ms ease-in; }
      .chat-outline { fill: #00000055; }
      .chat-background { fill: transparent; }
      [dark] .chat-outline { fill: rgba(255, 255, 255, 0.1); }
      [dark] svg.active path.chat-background { transition: all 250ms ease-in; }
    </style>
    <path fill="none" d="M0,0h24v24H0V0z"/>
    <path class="chat-background" d="M21.2,17.2L22,16V4l-0.8-1.6H2.5v18.5L6,17.4L21.2,17.2z"/>
    <path class="chat-outline" d="M20,18c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4l0,18l4-4H20z M4,17.2V4h16v12H5.2L4,17.2z M6,12h8v2H6V12z M6,9h12v2H6V9z M6,6h12v2H6V6z"/>
`,
  emailIcon: svg`
    <style>
      svg.active path.email-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      svg.active path.email-background { fill: transparent; transition: all 250ms ease-in; }
      [dark] svg.active path.email-background { transition: all 250ms ease-in; }
      .email-outline { fill: #00000055; }
      .email-background { fill: transparent; }
      [dark] .email-outline { fill: rgba(255, 255, 255, 0.1); }
    </style>
    <g id="Layer_1">
      <path fill="none" d="M0,0h24v24H0V0z"/>
      <path class="email-background" d="M19.5,19.5h-15c-1.1,0-2-0.9-2-2v-11c0-1.1,0.9-2,2-2h15c1.1,0,2,0.9,2,2v11C21.5,18.6,20.6,19.5,19.5,19.5z"
        />
    </g>
    <g id="Layer_2">
      <path class="email-outline" d="M4,20h16c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H4C2.9,4,2,4.9,2,6v12C2,19.1,2.9,20,4,20z M20,6l-8,5L4,6H20z
         M4,8l8,5l8-5v10H4V8z"/>
    </g>
`,
  smsIcon: svg`
    <style>
      .sms-background { fill: transparent; }
      .sms-outline { fill: #00000055; }
      [dark] .sms-outline { fill: rgba(255, 255, 255, 0.1); }
      .sms-dot { fill: #00000055; }
      [dark] .sms-dot { fill: rgba(255, 255, 255, 0.1); }
      svg.active path.sms-background { transition: all 250ms ease-in; }
      svg.active path.sms-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      svg.active path.sms-dot { fill: #969696; transition: all 250ms ease-in; }
    </style>
    <path class="sms-background" d="M23.47,10.16c0,5.38-5.16,9.74-11.52,9.74c-1.42,0-2.36-0.35-3.61-0.75c-0.89-0.28-3.3,1.77-4.07,1.32
	c-0.47-0.27,0.07-3.23-0.34-3.55c-2.26-1.78-3.5-3.94-3.5-6.76c0-5.38,5.16-9.74,11.52-9.74S23.47,4.78,23.47,10.16z"/>
    <path class="sms-outline" d="M3.29,19.15c0.35-2.43-0.28-2.17-1.21-3.29c-3.45-4.17-2.51-9.9,2.05-13.2c2.22-1.61,4.72-2.39,7.48-2.44
	c3.26-0.07,6.2,0.75,8.73,2.81c4.98,4.05,4.86,10.84-0.28,14.7c-3.38,2.54-7.21,3.15-11.3,2.25c-0.47-0.1-0.87-0.08-1.31,0.12
	c-1.2,0.56-2.42,1.07-3.62,1.62c-0.42,0.19-0.57,0.13-0.55-0.35C3.31,20.71,3.29,20.08,3.29,19.15z M4.58,19.97
	c1.01-0.44,1.92-0.83,2.83-1.26c0.42-0.2,0.79-0.21,1.24-0.09c3.71,0.97,7.22,0.51,10.39-1.72c4.9-3.45,4.91-9.7,0.09-13.24
	C14.98,0.63,8.75,0.67,4.7,3.81c-2.21,1.71-3.52,3.93-3.39,6.8c0.1,2.29,1.15,4.13,2.84,5.63c0.32,0.28,0.46,0.56,0.45,0.99
	C4.56,18.11,4.58,18.99,4.58,19.97z"/>
    <path class="sms-dot" d="M12.39,11.48h-0.83c-0.28,0-0.5-0.22-0.5-0.5v-0.83c0-0.28,0.22-0.5,0.5-0.5h0.83c0.28,0,0.5,0.22,0.5,0.5
		v0.83C12.89,11.26,12.67,11.48,12.39,11.48z"/>
    <path class="sms-dot" d="M8.12,11.48H7.29c-0.28,0-0.5-0.22-0.5-0.5v-0.83c0-0.28,0.22-0.5,0.5-0.5h0.83c0.28,0,0.5,0.22,0.5,0.5v0.83
		C8.62,11.26,8.4,11.48,8.12,11.48z"/>
    <path class="sms-dot" d="M16.72,11.48h-0.83c-0.28,0-0.5-0.22-0.5-0.5v-0.83c0-0.28,0.22-0.5,0.5-0.5h0.83c0.28,0,0.5,0.22,0.5,0.5
		v0.83C17.22,11.26,17,11.48,16.72,11.48z"/>
  `,
  settingsIcon: svg`
    <defs>
      <filter id="big_shadow">
        <feDropShadow dx="2" dy="2" stdDeviation="1"/>
      </filter>
    </defs>
    <style>
      svg.active path.settings-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
      svg.active path.settings-background { fill: transparent; transition: all 250ms ease-in; }
      .settings-outline { fill:#00000055; }
      .settings-background { fill:transparent; }
      [dark] .settings-outline { fill:rgba(255, 255, 255, 0.1); }
    </style>
    <path fill="none" d="M0 0h24v24H0V0z"/>
    <path class="settings-background" d="M21,7.7l-0.9-1.5l-1.6,0.6l-1.3,0.5l-1.1-0.9c-0.5-0.4-1-0.7-1.5-0.9l-1.3-0.5l-0.2-1.4L12.9,2h-1.7l-0.2,1.7
	l-0.2,1.4L9.4,5.6c-0.5,0.2-1,0.5-1.5,0.9L6.7,7.4L5.4,6.8L3.9,6.2L3,7.7l1.3,1l1.1,0.9L5.3,11c0,0.4-0.1,0.7-0.1,0.9
	c0,0.2,0,0.5,0.1,0.9l0.2,1.4l-1.1,0.9l-1.3,1l0.9,1.5L5.4,17l1.3-0.5l1.1,0.9c0.5,0.4,1,0.7,1.5,0.9l1.3,0.5l0.2,1.4l0.2,1.7h1.7
	l0.2-1.7l0.2-1.4l1.3-0.5c0.5-0.2,1-0.5,1.5-0.9l1.1-0.8l1.3,0.5l1.6,0.6l0.9-1.5l-1.3-1l-1.1-0.9l0.2-1.4c0-0.4,0.1-0.6,0.1-0.9
	c0-0.3,0-0.5-0.1-0.9l-0.2-1.4l1.1-0.9C19.6,8.7,21,7.7,21,7.7z M12,15.4c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4s3.4,1.5,3.4,3.4
	S13.9,15.4,12,15.4z"/>
    <path class="settings-outline" d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
`,
  helpIcon: svg`
    <style>
       svg.active path.help-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
       svg.active path.help-background { fill: transparent; transition: all 250ms ease-in; }
       .help-outline { fill: #00000055; }
       .help-background { fill: transparent; }
       [dark] .help-outline { fill: rgba(255, 255, 255, 0.1); }
    </style>
    <path fill="none" d="M0 0h24v24H0V0z"/>
    <path class="help-background" d="M12,2.5c-5.2,0-9.5,4.3-9.5,9.5s4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5S17.2,2.5,12,2.5z"/>
    <path class="help-outline" d="M11 16h2v2h-2zm1-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/>
`,
  supervisorIcon: svg`
  <style>
    svg.active path.supervisor-outline { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; }
    svg.active path.supervisor-background { fill: var(--v-xtium-robin-egg-blue); transition: all 250ms ease-in; opacity: 0.5; }
    .supervisor-outline { fill: #00000055; }
    .supervisor-background { fill: transparent; }
    .supervisor-letter { fill: #ffffff55; }
    .supervisor-letter-bg { fill: transparent; }
    [dark] .supervisor-outline { fill: rgba(255, 255, 255, 0.1); }
    svg.active .supervisor-letter { fill: #444; stroke-width: 0.3; stroke: #444; }
    svg.active .supervisor-letter-bg { fill: #ffffffff; }
    .supervisor-outline circle { fill: #999; }
  </style>

  <g>
    <path fill="none" d="M0 0h24v24H0V0z"/>
    <path class="supervisor-outline" d="M19,7.1C19,2.9,15.8,0,12,0C8.4,0,5.1,2.8,5.1,7.2C4.7,7.4,4.4,7.9,4.4,8.5v1.6c0,0.8,0.7,1.6,1.6,1.6h0.8V6.9c0-3,2.4-5.4,5.4-5.4s5.4,2.4,5.4,5.4v5.4h-6.2v1.6h6.2c0.8,0,1.6-0.7,1.6-1.6v-1c0.4-0.2,0.8-0.7,0.8-1.3V8.3C19.8,7.8,19.5,7.4,19,7.1z"/><circle cx="9.7" cy="7.7" r="0.8"/><circle cx="14.4" cy="7.7" r="0.8"/>
  </g>
  <g>
    <path class="supervisor-background" d="M16.7,6.2c-0.4-2.2-2.3-3.9-4.6-3.9s-4.8,2-4.7,5c1.9-0.8,3.3-2.5,3.8-4.5C12.2,4.8,14.3,6.2,16.7,6.2z"/>

    <path class="supervisor-letter-bg" d="M18.3,16.6h-4.7l-1-1c-0.3-0.3-0.8-0.3-1.1,0l-1,1H5.9c-0.8,0-1.6,0.7-1.6,1.6v4.2C4.3,23.3,5,24,5.9,24h12.3c0.8,0,1.6-0.7,1.6-1.6v-4.2C19.8,17.3,19.1,16.6,18.3,16.6z"/>
    <g>
      <path class="supervisor-letter" d="M5.9,18.4h1.3c0.3,0,0.8,0,1,0.1c0.2,0.1,0.4,0.4,0.4,0.8c0,0.4-0.2,0.7-0.6,0.8v0c0.5,0.1,0.7,0.4,0.7,0.9c0,0.5-0.4,1.1-1.1,1.1H5.9V18.4z M6.4,20h1c0.6,0,0.8-0.2,0.8-0.6c0-0.5-0.4-0.6-0.8-0.6h-1V20z M6.4,21.7h1.2c0.4,0,0.7-0.3,0.7-0.7c0-0.5-0.4-0.6-0.8-0.6H6.4V21.7z"/>
      <path class="supervisor-letter" d="M9.5,18.4H12v0.4H10V20h1.9v0.4H10v1.3h2.1v0.4H9.5V18.4z"/>
      <path class="supervisor-letter" d="M13.5,18.8h-1.2v-0.4h3v0.4H14v3.3h-0.5V18.8z"/>
      <path class="supervisor-letter" d="M16.2,18.4h0.5l1.5,3.7h-0.5L17.2,21h-1.6l-0.4,1.1h-0.5L16.2,18.4z M15.8,20.6h1.3l-0.6-1.7h0L15.8,20.6z"/>
    </g>
  </g>
  `,
  render
};
